import { useMetadata } from '#wa/composables/useMetadata'
import { useAppUtilityStore } from './useAppUtilityStore'

export default defineNuxtPlugin({
  dependsOn: ['vuexLoader'],
  name: 'appUtility',
  async setup(nuxtApp) {
    const appUtility = useAppUtilityStore()
    nuxtApp.provide('appUtility', appUtility)

    addRouteMiddleware(
      'metaDataMiddleware',
      async (to, from) => {
        const metadata = useMetadata()
        await metadata.loadAll()
      },
      {
        global: true,
      },
    )
  },
})
